class QuantityPriceUpdater {
  constructor() {
    this.initialized = false;
    this.clickHandler = null;
    this.init();
  }

  init() {
    const quantityInputs = document.querySelectorAll('quantity-input input[name="quantity"]');
    
    quantityInputs.forEach(input => {
      input.removeEventListener('change', input._priceUpdateHandler);
      input.removeEventListener('input', input._priceUpdateHandler);
      
      input._priceUpdateHandler = () => this.updatePrice(input);
      
      input.addEventListener('change', input._priceUpdateHandler);
      input.addEventListener('input', input._priceUpdateHandler);
      
      const initialQuantity = parseInt(input.value) || 1;
      if (initialQuantity > 1) {
        this.updatePrice(input);
      }
    });

    if (this.clickHandler) {
      document.removeEventListener('click', this.clickHandler);
    }
    
    this.clickHandler = (e) => {
      if (e.target.closest('.quantity__button')) {
        const quantityInput = e.target.closest('quantity-input');
        if (quantityInput) {
          const input = quantityInput.querySelector('input[name="quantity"]');
          if (input) setTimeout(() => this.updatePrice(input), 10);
        }
      }
    };
    
    document.addEventListener('click', this.clickHandler);
    this.initialized = true;
  }

  updatePrice(input) {
    if (!input) return;
    const quantity = parseInt(input.value) || 1;
    
    if (document.querySelector('.price-per-item-wrapper, [id*="Price-Per-Item"]')) {
      return;
    }
    
    const sectionId = this.getSectionId(input);
    if (!sectionId) return;
    
    const priceElement = document.querySelector(`.price[data-section-id="${sectionId}"][data-base-price]`);
    if (!priceElement) return;
    
    const basePrice = parseInt(priceElement.dataset.basePrice);
    const baseComparePrice = parseInt(priceElement.dataset.baseComparePrice);
    
    if (!basePrice) return;
    
    const newPrice = basePrice * quantity;
    const newComparePrice = baseComparePrice * quantity;
    
    const regularPriceElements = priceElement.querySelectorAll('.price__regular .price-item--regular');
    regularPriceElements.forEach(el => {
      el.textContent = this.formatMoney(newPrice);
    });
    
    const salePriceElements = priceElement.querySelectorAll('.price__sale .price-item--sale');
    salePriceElements.forEach(el => {
      el.textContent = this.formatMoney(newPrice);
    });
    
    if (baseComparePrice > basePrice) {
      const compareAtPriceElements = priceElement.querySelectorAll('.price__sale .price-item--regular');
      compareAtPriceElements.forEach(el => {
        el.textContent = this.formatMoney(newComparePrice);
      });
    }
  }

  getSectionId(input) {
    const inputId = input.id;
    const match = inputId.match(/Quantity-(.+)/);
    return match ? match[1] : null;
  }

  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      let moneyFormat = window.theme?.moneyFormatWithoutTrailingZeros || window.moneyFormat;
      moneyFormat = moneyFormat.replace('{{amount}}', '{{amount_no_decimals}}')
                               .replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
                               .replace('{{amount_with_space_separator}}', '{{amount_no_decimals_with_space_separator}}')
                               .replace('{{amount_with_period_and_space_separator}}', '{{amount_no_decimals_with_space_separator}}');
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }
}

let quantityPriceUpdaterInstance = null;

function initQuantityPriceUpdater() {
  if (!quantityPriceUpdaterInstance) {
    quantityPriceUpdaterInstance = new QuantityPriceUpdater();
  } else {
    quantityPriceUpdaterInstance.init();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantityPriceUpdater);
} else {
  initQuantityPriceUpdater();
}

document.addEventListener('afterVariantChanged', () => {
  setTimeout(initQuantityPriceUpdater, 100);
});

document.addEventListener('afterQuantityUpdate', () => {
  setTimeout(() => {
    const quantityInputs = document.querySelectorAll('quantity-input input[name="quantity"]');
    quantityInputs.forEach(input => {
      if (quantityPriceUpdaterInstance) {
        quantityPriceUpdaterInstance.updatePrice(input);
      }
    });
  }, 50);
});
